declare module '@mui/material/styles' {
  interface TypographyVariants {
    paragraph: React.CSSProperties
    helper: React.CSSProperties
  }
  interface TypographyVariantsOptions {
    paragraph?: React.CSSProperties
    helper: React.CSSProperties
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    paragraph: true
    helper: true
  }
}

export const typography = {
  fontSize: 13,
  h1: {
    fontFamily: 'Rajdhani',
    fontSize: '39.8px',
    fontWeight: 700,
  },
  h2: {
    fontFamily: 'Rajdhani',
    fontSize: '33.2px',
    fontWeight: 700,
  },
  h3: {
    fontFamily: 'Rajdhani',
    fontSize: '27.8px',
    fontWeight: 700,
  },
  h4: {
    fontFamily: 'Rajdhani',
    fontSize: '23px',
    fontWeight: 700,
  },
  h5: {
    fontFamily: 'Rajdhani',
    fontSize: '19.2px',
    fontWeight: 700,
  },
  h6: {
    fontFamily: 'Rajdhani',
    fontWeight: 700,
  },
  paragraph: {
    fontSize: '16px',
  },
  helper: {
    fontSize: '13.3px',
  },
  subtitle2: {
    fontSize: '0.8rem',
  },
  caption: {
    fontSize: '0.702rem',
  },
  body2: {
    fontSize: '0.79rem',
  },
  button: {
    fontSize: '0.79rem',
  },
}
